import { message } from "antd"
import styles from "./index.module.scss"
import { useContext, useEffect } from "react"
import Utils from '@utils/utils';
import { useNavigate, useParams } from "react-router-dom";
import API from "@api/api";
import UploadBox from "../components/UploadBox";
import { BatchImagesContext } from "../BatchImagesContext.js";
import GoBack from "../components/GoBack";
import { BATCH_IMAGES_TYPE } from "@utils/CONST";


export default function UploadPage() {
    const { setProjectType, setFileList } = useContext(BatchImagesContext)
    const navigate = useNavigate()
    const { projectType } = useParams()

    useEffect(() => {
        setFileList([])
    }, [])

    const handleUpload = async (file, fileList) => {
        try {
            // 需要登录
            const status = Utils.checkLoginStatus(() => null)
            if (!status) return
            if (fileList.length == 0) return
            setFileList(fileList)
            setProjectType(projectType)
            API.addProject({
                projectType: projectType,
            }).then(res => {
                if (res?.code != 0) throw new Error(res.message)
                if (res?.data?.id) {
                    navigate(`/home/product/${res?.data?.id}/config`)
                }
            }).catch(err => message.error(err.message))

        } catch (err) {
            console.error(err.message)
        }
    }

    // 从我的项目中选图创建项目
    const handleMyProjectUpload = (urlList) => {
        try {
            // 需要登录
            const status = Utils.checkLoginStatus(() => null)
            if (!status) return
            if (urlList.length == 0) return
            setProjectType(projectType)
            API.addProject({
                projectType: projectType,
            }).then(res => {
                if (res?.code != 0) throw new Error(res.message)
                if (res?.data?.id) {
                    const smartPageUrlList = []
                    urlList.map(item => {
                        smartPageUrlList.push({
                            url: item.results?.[0].image,
                            mainImage: true
                        })
                    })

                    const maxCount = projectType === BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? 14 : 50
                    if (smartPageUrlList.length > maxCount) {
                        smartPageUrlList.splice(maxCount)
                    }

                    API.batchSaveSku([{
                        projectId: res?.data?.id,
                        projectType: projectType,
                        skuName: '服装详情页',
                        skuId: '',
                        inputImages: smartPageUrlList
                    }]).then(res2 => {
                        if (res2?.code == 0) {
                            navigate(`/home/product/${res?.data?.id}/config`)
                        } else throw new Error(res2.message)

                    }).catch(err => message.error(err.message))
                }
            }).catch(err => message.error(err.message))

        } catch (err) {
            console.error(err.message)
        }
    }

    return (
        <>
            <div className={styles.UploadPage}>
                <div className={styles.Content}>
                    <div className={styles.GoBack}>
                        <GoBack onClick={() => navigate("/home/product/batchImages")} />
                    </div>
                    <UploadBox
                        projectType={projectType}
                        onUpload={handleUpload}
                        onMyProjectUpload={handleMyProjectUpload}
                    />
                </div>
            </div>

        </>

    )
}
